import { Button } from "@joonapp/web-shared"

import { useSessionBillingPeriodsQuery } from "../../../../networking/sessions/queries"
import { ANALYTIC_EVENTS } from "../../../../util/analytics"
import { trackAnalyticEvent } from "../../../../util/analytics"
import useSession from "../hooks/useSession"

const ScheduleNextSessionButton = () => {
  const { data: billingPeriods } = useSessionBillingPeriodsQuery()

  const { handleSchedule } = useSession(undefined)

  const billingPeriodWithOpenSession = billingPeriods?.find(
    (period) => period.bookings.length < period.max_bookings
  )

  if (!billingPeriodWithOpenSession) return <></>

  return (
    <Button
      buttonType="secondary"
      text="Schedule next session"
      onClick={() => {
        handleSchedule(billingPeriodWithOpenSession)
        trackAnalyticEvent(
          ANALYTIC_EVENTS.POST_SESSION_FLOW_SCHEDULE_NEXT_SESSION
        )
      }}
    />
  )
}

export default ScheduleNextSessionButton
